import React, { useState, useEffect, useReducer } from "react";
import ToastNotification from "Components/UI/ToastNotification";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { all_routes } from "Router/all_routes";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { DatePicker, Table } from "antd";
import { Save } from "react-feather";
import { Link, useNavigate } from "react-router-dom";
import {
  format,
  getDaysInMonth,
  startOfMonth,
  addDays,
  toDate,
  endOfMonth,
} from "date-fns";
import { useForm, FormProvider, Controller } from "react-hook-form";
import MonthlyAttendanceRow from "Components/UI/MonthlyAttendanceRow";
import { Alert, Spin } from "antd";
import Select from "react-select";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import Swal from "sweetalert2";
import { checkIsPublicHoliday } from "core/Operations/attendance/checkPublicHoliday";
import { useCreateMonthlyAttendanceMutation } from "AppQuries/attendance/add-attendance";
import { useGetEmployeeQuery } from "AppQuries/employee/employee_list";
import { useGetPublicHolidaysQuery } from "AppQuries/leave/public-holiday/public-holiday";
import Error404 from "MainPages/ErrorPages/error404";
import moment from "moment";
import MonthlyAttendanceTable from "./MonthlyAttendanceTable";
import { useGetShiftSheduleQuery } from "AppQuries/shift/schedule/scheduler";
import { getCurrentFormattedDate } from "core/Operations/currentDateTime";
import { useGetAllDepartmentQuery } from "AppQuries/master/Department/get-all-departments";
import { toast } from "core/Operations/toast";
const MonthlyAttendance = () => {
  const userData = useSelector(loggedInUser);
  const [employeeAttendanceList, setEmployeeAttendanceList] = useState([]);
  
  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isMount, setIsMount] = useState(false);
  const [loadingRows, setLoadingRows] = useState(false);
  const [attendanceMonth, setAttendanceMonth] = useState();
  const [attendanceYear, setAttendanceYear] = useState(0);
  const [daysInMonth, setDaysInMonth] = useState();
  const [daysInfo, setDaysInfo] = useState([]);
  const [showAttendanceSheet, setShowAttendanceSheet] = useState(false);
  const [showAttendanceButton, setShowAttendanceButton] = useState(false);
  const [scheduleData, setScheduleData] = useState([]);
  const [loadScheduleData, setLoadScheduleData] = useState(false);
  const [scheduleMap, setScheduleMap] = useState([]);
  const [employeeCode, setEmployeeCode] = useState(0);
  const {
    data: employeesData,
    isError,
    error,
  } = useGetEmployeeQuery({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
  });

  // const { data : departments } = useGetAllDepartmentQuery({})

  const employeeOptions =
    employeesData
      ?.filter((d) => d.isActive)
      .map((o) => ({
        id: o.employeeCode,
        label: `${o.uniqueId}-${o.fullName}`,
        value: o.employeeCode,
      })) || [];

  const {
    data,
    isLoading: gettingScheduleData,
    refetch: refetchScheduleData,
  } = useGetShiftSheduleQuery({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    fromDate:
      attendanceYear > 0
        ? format(
            startOfMonth(new Date(attendanceYear, attendanceMonth, 1)),
            "yyyy-MM-dd"
          )
        : format(startOfMonth(new Date()), "yyyy-MM-dd"),
    toDate:
      attendanceYear > 0
        ? format(
            endOfMonth(new Date(attendanceYear, attendanceMonth, 1)),
            "yyyy-MM-dd"
          )
        : format(endOfMonth(new Date()), "yyyy-MM-dd"),
  });

  const { data: publicHolidays } = useGetPublicHolidaysQuery({
    companyCode: userData?.companyCode,
  });
  const {
    mutate: createMonthlyAttendance,
    isPending,
    isFetching,
    isError: isCreatingAttendaceError,
    error: creatingAttendaceError,
  } = useCreateMonthlyAttendanceMutation();
  const navigate = useNavigate();

  const methods = useForm({
    defaultValues: {
      createUser: userData.userName,
      modifyUser: userData.userName,
      createDate: getCurrentFormattedDate(),
      modifyDate: getCurrentFormattedDate(),
      isCheck: false,
    },
  });

  const {
    control,
    register,
    setValue,
    watch,
    getValues,
    handleSubmit,
    reset,
    formState: { errors },
  } = methods;

  const mapScheduleIdToAttendance = (employeeCode, attendanceDate) => {
    const scheduleMap = {};

    const key = `${employeeCode}-${attendanceDate}`;

    // attendanceData = attendanceData.map((attendance) => {
    //   const key = `${attendance.employeeCode}-${attendance.scheduleDate}`;
    //   return {
    //     ...attendance,
    //     scheduleId: scheduleMap[key] || null, // Assign scheduleId if found, otherwise null
    //   };
    // });

    return scheduleMap[key];
  };

  const onSubmit = (data) => {
    Swal.fire({
      title: "Confirm to save attendance?",
      text: "Are you sure you want save attendance",
      type: "warning",
      showCancelButton: !0,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Submit it!",
      confirmButtonClass: "btn btn-primary",
      cancelButtonClass: "btn btn-danger ml-1",
      buttonsStyling: 1,
      buttons: ["Cancel", "Submit"],
    }).then(function (t) {
      if (t.isConfirmed) {
        const attendance = data.employeeCode.flatMap((emp_code) =>
          watch(`attendanceMarked[${emp_code}]`)
            ? Array.from({ length: daysInMonth }, (_, i) => {
                const isCheck =
                  getValues(`attendance[${emp_code}].isCheck[${i}]`) || false;

                if (isCheck) {
                  const attendanceValue =
                    Number(
                      getValues(`attendance[${emp_code}].attendanceValue[${i}]`)
                    ) || 0;
                  const inTime = getValues(
                    `attendance[${emp_code}].attendanceInTime[${i}]`
                  );
                  const outTime = getValues(
                    `attendance[${emp_code}].attendanceOutTime[${i}]`
                  );
                  const attendanceDate = getValues(`attendanceDate[${i}]`);
                  const scheduleId = getValues(
                    `attendance[${emp_code}].scheduleId[${i}]`
                  );
                  return {
                    employeeCode: emp_code,
                    attendanceValue: attendanceValue,
                    inTime: inTime,
                    outTime: outTime,
                    createDate: data.createDate,
                    createUser: data.createUser,
                    attendanceDate: attendanceDate,
                    modifyUser: data.createUser,
                    modifyDate: data.createDate,
                    isCheck: isCheck,
                    scheduleId: scheduleId,
                    projectCode: "",
                    remarks: "",
                    mode: "MM",
                    waitingTime: "00:00:00",
                    wtrot:"00:00:00",
                    isApproved: false,
                    oT1: 0,
                    oT2: 0,
                    extraCharge: 0,
                    wtnhEdit: false,
                    supplierCompany: "",
                    service: "",
                    isReviewed: false,
                    reviewDate: "",
                    reviewBy: "",
                    approvedDate: "",
                    approvedBy: "",
                  };
                }

                return null;
              }).filter(Boolean)
            : []
        );
        
        if (attendance.length > 0) {
          const input = {
            companyCode: userData.companyCode,
            attendanceYear: Number(attendanceYear),
            attendanceMonth: Number(attendanceMonth + 1),
            locationCode: userData.locationCode,
            attendance,
          };

          createMonthlyAttendance(input, {
            onSuccess: (response) => {
              const isSuccessful = response[0]?.response;

              if (isSuccessful) {
                Swal.fire({
                  type: "success",
                  title: "Attendance Saved!",
                  text: "Monthly Attendance Saved Successfully..",
                  confirmButtonClass: "btn btn-success",
                }).then(function (t) {
                  navigate(
                    `${all_routes.attendance}${all_routes.attendance_filter}`
                  );
                });
              } else {
                Swal.fire({
                  title: "Warning!",
                  text: response[0].errorMessage,
                  type: "warning",
                  confirmButtonColor: "#3085d6",
                  confirmButtonText: "Ok",
                  confirmButtonClass: "btn btn-primary",
                  okButtonClass: "",
                  buttonsStyling: 1,
                });
              }
            },
            onError: (error) => {
              toast.error(error.message || "Something went wrong.");
              
            },
          });
        } else {
          Swal.fire({
            title: "Failed!",
            text: "Please enter attendance details",
            type: "warning",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Ok",
            confirmButtonClass: "btn btn-primary",
            okButtonClass: "",
            buttonsStyling: 1,
          });
        }
      }
    });
    setIsLoading(true);

    setIsLoading(false);
  };

  const validateDate = (date) => {
    const parsedDate = new Date(date);
    return !isNaN(parsedDate);
  };

  const loadMonthlyAttendaceData = () => {
    setIsLoading(true);

    try {
      const startDate = new Date(attendanceYear, attendanceMonth, 1);

      const daysArray = Array.from({ length: daysInMonth }, (_, index) => {
        const currentDate = addDays(startOfMonth(startDate), index);

        const formattedDate = format(currentDate, "yyyy-MM-dd");

        if (!validateDate(currentDate)) {
          throw new Error(`Invalid date: ${currentDate}`);
        }
        setValue(`attendanceDate[${index}]`, formattedDate);

        return {
          date: format(currentDate, "dd-MMM"),
          dayName: format(currentDate, "EEE"),
          isWeekEnd: false, // format(currentDate, "EEE") === "Sun",
          isPublicHoliday: checkIsPublicHoliday(publicHolidays, formattedDate),
        };
      });

      setDaysInfo(daysArray);
    } catch (error) {
      console.error("Error loading attendance data:", error);
    } finally {
      setLoadingRows(false);
      setShowAttendanceSheet(true);
      setIsLoading(false);
    }
  };

  const defaultStates = {};

  const setAttendance = (id, row, attendanceValue) => {
    const schedule =
      scheduleMap[`${id}-${getValues(`attendanceDate[${row}]`)}`];
    const attendaceDay = format(
      new Date(watch(`attendanceDate[${row}]`)),
      "EEEE"
    ).toLocaleLowerCase();
    // let startTime =
    //   attendanceValue === 0
    //     ? "00:00:00"
    //     : attendanceValue === 0.5
    //     ? moment(schedule?.shiftInTimeStr, ["HH:mm"]).format("HH:mm:ss")
    //     : schedule
    //     ? moment(schedule?.shiftInTimeStr, ["HH:mm"]).format("HH:mm:ss")
    //     : userData?.companyOpenTime;

    // let endTime =
    //   attendanceValue === 1
    //     ? schedule
    //       ? moment(schedule?.shiftOutTimeStr, ["HH:mm"]).format("HH:mm:ss")
    //       : userData?.companyCloseTime
    //     : attendanceValue === 0
    //     ? "00:00:00"
    //     : moment(schedule?.shiftInTimeStr, ["HH:mm"])
    //         .add(4, "hours")
    //         .format("HH:mm:ss");

    //  Latest working flow
    let startTime =
      attendanceValue === 0
        ? "00:00:00"
        : attendanceValue === 0.5
        ? moment(schedule?.shiftInTimeStr, ["HH:mm"], true).isValid()
          ? moment(schedule?.shiftInTimeStr, ["HH:mm"]).format("HH:mm:ss")
          : userData?.companyOpenTime
        : schedule &&
          moment(schedule?.shiftInTimeStr, ["HH:mm"], true).isValid()
        ? moment(schedule?.shiftInTimeStr, ["HH:mm"]).format("HH:mm:ss")
        : moment(userData?.companyOpenTime, ["HH:mm"]).format("HH:mm:ss");

    let endTime =
      attendanceValue === 1
        ? schedule &&
          moment(schedule?.shiftOutTimeStr, ["HH:mm"], true).isValid()
          ? moment(schedule?.shiftOutTimeStr, ["HH:mm"]).format("HH:mm:ss")
          : moment(userData?.companyCloseTime, ["HH:mm"]).format("HH:mm:ss")
        : attendanceValue === 0
        ? "00:00:00"
        : moment(schedule?.shiftInTimeStr, ["HH:mm"], true).isValid()
        ? moment(schedule?.shiftInTimeStr, ["HH:mm"])
            .add(4, "hours")
            .format("HH:mm:ss")
        : moment(userData?.companyOpenTime, ["HH:mm"])
            .add(4, "hours")
            .format("HH:mm:ss");

    const [hours1, minutes1, sec1] = startTime.split(":");
    const [hours2, minutes2, sec2] = endTime.split(":");

    // const [hours1, minutes1, sec1] = userData[`${attendaceDay}OpenTime`] ?
    //   userData[`${attendaceDay}OpenTime`].split(":") : userData.companyOpenTime.split(":");
    // const [hours2, minutes2, sec2] = userData[`${attendaceDay}CloseTime`] ?
    //   userData[`${attendaceDay}CloseTime`].split(":") : userData.companyCloseTime.split(":");

    const date1 = new Date();
    date1.setHours(hours1);
    date1.setMinutes(minutes1);
    // date1.setSeconds(sec1);

    const date2 = new Date();
    date2.setHours(hours2);
    date2.setMinutes(minutes2);
    // date2.setSeconds(sec2);

    const diff = date2 - date1;

    const hoursDiff = Math.floor(Number(diff) / (1000 * 60 * 60));
    const minutesDiff = Math.floor(
      (Number(diff) % (1000 * 60 * 60)) / (1000 * 60)
    );
    // const secondsDeiff = Math.floor((Number(diff) % (1000 * 60 * 60)) / (1000 * 60) * (1000*6));

    let totalHours = `${hoursDiff}:${minutesDiff}:00`;

    setValue(
      `attendance[${id}].attendanceValue[${row}]`,
      Number(attendanceValue)
    );
    setValue(
      `attendance[${id}].scheduleId[${row}]`,
      schedule ? schedule?.scheduleId : 0
    );

    setValue(`attendance[${id}].attendanceInTime[${row}]`, startTime);
    setValue(`attendance[${id}].attendanceOutTime[${row}]`, endTime);

    // setValue(
    //   `attendance[${id}].attendanceInTime[${row}]`,
    //   userData[`${attendaceDay}OpenTime`].split(":")
    // );
    // setValue(
    //   `attendance[${id}].attendanceOutTime[${row}]`,
    //   userData[`${attendaceDay}CloseTime`].split(":")
    // );
    setValue(`attendance[${id}].totalHours[${row}]`, totalHours);
    setValue(
      `attendance[${id}].isCheck[${row}]`,
      true
      // attendanceValue === 0 ? false : true
    );
  };

  const attendanceHandler = (state, action) => {
    // setIsLoading(true);

    const markAttendanceForDay = (employeeCode, dayIndex, isPresent) => {
      const isPublicHoliday = checkIsPublicHoliday(
        publicHolidays,
        getValues(`attendanceDate[${dayIndex}]`)
      );

      const restData = watch(`restDay[${employeeCode}]`)?.split(",") || [];

      const fullRestDay = restData
        .filter((v) => v.includes("-1"))
        .map((d) => d?.split("-")[0]);
      const halfRestDay = restData
        .filter((v) => v.includes("-0.5"))
        .map((d) => d?.split("-")[0]);

      const day = moment(getValues(`attendanceDate[${dayIndex}]`)).format(
        "dddd"
      );

      const isRestDay = Array.isArray(fullRestDay) && fullRestDay.includes(day);
      const isHalfRestDay =
        Array.isArray(halfRestDay) && halfRestDay.includes(day);

      setAttendance(
        employeeCode,
        dayIndex,
        isPresent && !(isRestDay || isPublicHoliday || isHalfRestDay)
          ? 1
          : isHalfRestDay
          ? 0.5
          : 0
      );
    };

    const markAllAttendance = (status) => {
      employeeAttendanceList?.forEach((data, _id) => {
        setValue(`isPresent[${data.employeeCode}]`, status);
        setValue(
          `attendanceMarked[${data.employeeCode}]`,
          status === 0 ? false : true
        );
        for (let i = 0; i < daysInMonth; i++) {
          markAttendanceForDay(data.employeeCode, i, status);
        }
      });
    };

    switch (action.type) {
      case "MARK_PRESENT":
        setValue(`isPresent[${action.data.id}]`, action.data.status);
        setValue(
          `attendanceMarked[${action.data.id}]`,
          action.data.status === 0 ? false : true
        );
        for (let i = 0; i < daysInMonth; i++) {
          markAttendanceForDay(action.data.id, i, action.data.status);
        }
        break;

      case "INTIME_CHANGE":
        setValue(
          `attendance[${action.data.id}].attendanceInTime[${action.data.row}]`,
          action.data.value
        );
        calculateTotalHours(action.data.id, action.data.row);
        break;

      case "OUTTIME_CHANGE":
        setValue(
          `attendance[${action.data.id}].attendanceOutTime[${action.data.row}]`,
          action.data.value
        );
        calculateTotalHours(action.data.id, action.data.row);
        break;

      case "MARK_ALL":
        markAllAttendance(action.data.status);
        break;

      case "CHOOSE_ATTENDANCE":
        setAttendance(action.data.id, action.data.row, action.data.value);
        break;

      default:
        console.error(`Unhandled action type: ${action.type}`);
        break;
    }

    // setIsLoading(false);
  };

  const calculateTotalHours = (id, row) => {
    const [hours1, minutes1] = getValues(
      `attendance[${id}].attendanceInTime[${row}]`
    ).split(":");
    const [hours2, minutes2] = getValues(
      `attendance[${id}].attendanceOutTime[${row}]`
    ).split(":");

    const date1 = new Date();
    date1.setHours(hours1);
    date1.setMinutes(minutes1);

    const date2 = new Date();
    date2.setHours(hours2);
    date2.setMinutes(minutes2);

    const diff = date2 - date1;

    const hoursDiff = Math.floor(diff / (1000 * 60 * 60));
    const minutesDiff = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

    setValue(
      `attendance[${id}].totalHours[${row}]`,
      `${hoursDiff}:${minutesDiff}`
    );
  };

  const [leaveState, dispatch] = useReducer(attendanceHandler, defaultStates);

  useEffect(() => {
    const fetchData = async () => {
      const { data: s1 } = await refetchScheduleData({
        companyCode: userData?.companyCode,
        fromDate:
          attendanceYear > 0
            ? format(
                startOfMonth(new Date(attendanceYear, attendanceMonth, 1)),
                "yyyy-MM-dd"
              )
            : format(startOfMonth(new Date()), "yyyy-MM-dd"),
        toDate:
          attendanceYear > 0
            ? format(
                endOfMonth(new Date(attendanceYear, attendanceMonth, 1)),
                "yyyy-MM-dd"
              )
            : format(endOfMonth(new Date()), "yyyy-MM-dd"),
      });
      const mapData = {};

      s1.forEach((schedule) => {
        const key = `${schedule.employeeCode}-${format(
          new Date(schedule.scheduleDate),
          "yyyy-MM-dd"
        )}`;
        mapData[key] = schedule;
      });
      setScheduleMap(mapData);
    };

    if (attendanceYear > 0) {
      fetchData();
    }
  }, [attendanceMonth, attendanceYear]);


  useEffect(() => {
    reset();
    if (employeesData?.data) {
      const empAttendanceData =
        employeesData?.data
          .filter(
            (d) =>
              d.isActive === true &&
              (d.employeeCode === employeeCode || employeeCode === 0)
          )
          .map((data, _id) => {
            setValue(`employeeCode[${_id}]`, data.employeeCode);
            setValue(`restDay[${data.employeeCode}]`, data.restDay);
            setValue(`attendanceMarked[${data.employeeCode}]`, false);
            return {
              id: _id,
              employeeCode: data.employeeCode,
              fullName: data.fullName,
            };
          }) || [];
      setEmployeeAttendanceList(empAttendanceData);
    }
  }, [employeesData, employeeCode]);

  if (
    isLoading ||
    isFetching ||
    gettingScheduleData ||
    createMonthlyAttendance.status === "pending"
  )
    return <LoadingSpinner />;
  if (isError) return <Error404 error={error} />;
  if (isCreatingAttendaceError)
    return <Error404 error={creatingAttendaceError} />;
  return (
    <div>
     
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)} className="needs-validation">
          <div className="page-wrapper">
            <div className="content">
              <div className="page-header">
                <div className="add-item d-flex">
                  <div className="page-title">
                    <h4>Monthly Attendance</h4>
                    <h6>Add your employees attendance</h6>
                  </div>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
                  >
                    <Link
                      to={`${all_routes.attendance}${all_routes.attendance_filter}`}
                      className="btn btn-added"
                      // disabled={isFetching || addAttendanceFetching}
                    >
                      <i className="fas fa-reply me-2"></i>
                      Back
                    </Link>
                  </OverlayTrigger>
                </div>
                {showAttendanceSheet && (
                  <div className="page-btn">
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="add-new-tooltip">Save Attendance</Tooltip>
                      }
                    >
                      <button
                        to={`${all_routes.attendance}${all_routes.attendance_filter}`}
                        className="btn btn-added"
                        type="submit"
                        //   disabled={isFetching || addAttendanceFetching}
                      >
                        {/* {isFetching || addAttendanceFetching ? (
                        <>
                          <i className="fas fa-spinner fa-spin me-2" />
                          Loading...
                        </>
                      ) : ( */}
                        <>
                          <Save className="me-2" />
                          Save Attendance
                        </>
                        {/* )} */}
                      </button>
                    </OverlayTrigger>
                  </div>
                )}
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="card table-list-card border-0">
                    <div className="card-header">
                      <div className="form-row row">
                        {/* <div className="col-lg-3 col-sm-6 col-md-3 col-12">
                          <label className="form-label">
                            Employee
                            <span className="asterisk">*</span>
                          </label>
                          <Select
                            className="select"
                            options={employeeOptions}
                            placeholder="Employee"
                            value={employeeOptions.find(
                              (option) => option.value === employeeCode
                            )}
                            onChange={(e) => {
                              setEmployeeCode(e?.value || 0);
                            }}
                            isClearable
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                          />
                        </div> */}
                        <div className="col-lg-3 col-sm-6 col-md-3 col-12">
                          <label className="form-label">
                            Attendance Month And Year
                            <span className="asterisk">*</span>
                          </label>
                          {/* <Controller
                            name="attendanceDate"
                            control={control}
                            // defaultValue={watch("attendanceDate")}
                            render={({ field }) => ( */}
                          <DatePicker
                            // {...field}
                            className={`form-control ${
                              errors.attendanceDate ? "is-invalid" : ""
                            }`}
                            placeholder="Select Attendace Month & Year"
                            picker="month"
                            onChange={(date) => {
                              if (date) {
                                setShowAttendanceSheet(false);
                                setAttendanceMonth(date.month());
                                setAttendanceYear(date.year());
                                setDaysInMonth(date.daysInMonth());
                                setShowAttendanceButton(true);
                              }
                            }}
                            getPopupContainer={(trigger) => trigger.parentNode}
                          />
                          {/* )}
                          /> */}
                          {/* {errors.attendanceDate && (
                        <div className="invalid-feedback">
                          {errors.attendanceDate?.message || "Invalid input"}
                        </div>
                      )} */}
                        </div>
                        <div className="col-lg-3 col-sm-6 col-md-3 col-12">
                          <label className="form-label">&nbsp;</label>
                          <div className="input-blocks">
                            <button
                              className="form-control btn btn-secondary ms-auto"
                              onClick={loadMonthlyAttendaceData}
                              disabled={!showAttendanceButton}
                              type="button"
                            >
                              <i
                                data-feather="search"
                                className="feather-search"
                              />
                              &nbsp; Get Attendance Data
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      <Spin spinning={loadingRows}>
                        {loadingRows && (
                          <Alert
                            message="Attendance date fetching"
                            description=""
                            type="info"
                          />
                        )}
                        {error && (
                          <Alert
                            message={error.code}
                            description={error.message}
                            type="warning"
                          />
                        )}
                      </Spin>
                      {showAttendanceSheet && (
                        <div style={{ overflowX: "scroll" }}>
                          <div
                            className="table-responsive"
                            style={{ padding: "0px" }}
                          >
                            <MonthlyAttendanceTable
                              workingDays={daysInMonth}
                              employeeAttendanceList={employeeAttendanceList}
                              dispatch={dispatch}
                              daysInfo={daysInfo}
                              isLoading={isLoading}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                    {showAttendanceSheet && (
                      <div className="card-footer">
                        <div className="text-end">
                          <button
                            className="btn btn-primary"
                            type="submit"
                            disabled={isFetching}
                          >
                            {isFetching ? (
                              <>
                                <i className="fas fa-spinner fa-spin me-2" />
                                Loading...
                              </>
                            ) : (
                              <>
                                <Save className="me-2" />
                                Save Attendance
                              </>
                            )}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </FormProvider>
    </div>
  );
};

export default MonthlyAttendance;
